import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { authFetch, useAuth } from "../context/AuthContext";

export default function PaymentSuccess() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const [status, setStatus] = useState("pending");
    const attempts = useRef(0);

    useEffect(() => {
        if (!sessionId) {
            navigate("/subscribe");
            return;
        }
        const poll = async () => {
            if (attempts.current >= 8) {
                setStatus("timeout");
                return;
            }
            attempts.current += 1;
            try {
                const res = await authFetch("get", `/payments/status/${sessionId}`);
                if (res.data.payment_status === "paid") {
                    setStatus("paid");
                    await refresh();
                    setTimeout(() => navigate("/dashboard"), 2000);
                    return;
                }
                if (res.data.status === "expired") {
                    setStatus("expired");
                    return;
                }
                setTimeout(poll, 2000);
            } catch {
                setTimeout(poll, 2000);
            }
        };
        poll();
    }, [sessionId, navigate, refresh]);

    return (
        <>
            <Navbar />
            <main className="min-h-screen pt-28 pb-12 px-6 flex items-center justify-center">
                <div className="glass-gold p-12 max-w-xl w-full text-center" data-testid="payment-result-card">
                    {status === "pending" && (
                        <>
                            <p className="label-tracking text-gold">Processing</p>
                            <h1 className="font-serif text-4xl mt-3">Aligning the stars...</h1>
                            <p className="text-muted mt-3">Verifying your cosmic gift.</p>
                        </>
                    )}
                    {status === "paid" && (
                        <>
                            <p className="label-tracking text-gold">Welcome to Premium</p>
                            <h1 className="font-serif text-5xl mt-3">The sky opens</h1>
                            <p className="text-muted mt-3">Redirecting to your dashboard...</p>
                        </>
                    )}
                    {status === "expired" && (
                        <>
                            <p className="label-tracking text-gold">Session expired</p>
                            <h1 className="font-serif text-3xl mt-3">Please try again</h1>
                        </>
                    )}
                    {status === "timeout" && (
                        <>
                            <h1 className="font-serif text-3xl mt-3">Status pending</h1>
                            <p className="text-muted mt-3">Check your email — your subscription may already be active.</p>
                        </>
                    )}
                </div>
            </main>
        </>
    );
}
